var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 1.8335H14.6663",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.49984L6.86193 6.63791C7.08415 6.41569 7.19526 6.30458 7.33333 6.30458C7.4714 6.30458 7.58252 6.41569 7.80474 6.63791L8.19526 7.02843C8.41748 7.25066 8.5286 7.36177 8.66667 7.36177C8.80474 7.36177 8.91585 7.25065 9.13807 7.02843L10 6.1665",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5L8 11.8333",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 15.1667L8.00033 14.5",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 15.1667L8 14.5",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 1.8335V7.50016C2.66699 9.54292 2.66699 10.5643 3.33646 11.1989C4.00593 11.8335 5.08343 11.8335 7.23842 11.8335H8.76223C10.9172 11.8335 11.9947 11.8335 12.6642 11.1989C13.3337 10.5643 13.3337 9.54292 13.3337 7.50016V7.16683M13.3337 1.8335V4.50016",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.9cd0cfa3.svg";
export { ForwardRef as ReactComponent };